// 详情模块
import { status as conversationStatus } from '@/constants/conversation.js'
import { SET_SELECTION_MARKDOWN_TEXT, SET_CURRENT_SESSION_IS_OVER } from '@/store/mutation-types'
import { getLocalStorage, setLocalStorage } from '@/utils/locatonStorge'

const Conversation = {
  namespaced: true,
  state: {
    mode: conversationStatus.prod,
    dataList: [], // 数据列表
    taskId: '', // 对话id
    initStatus: true, // 用户进入页面
    conversationId: '',
    // 全局对话状态
    isSearching: false, // 正在提问
    isOver: false, // 终止当前对话

    retryCanUse: true, // 重试按钮
    isStreamStoped: false, // 暂停
    searchStart: false,
    // 解决bug, 临时方案
    defaultObjet: {},

    currentOnClickedStatus: false, // 是否处于分享状态
    thumbsUpModelIndex: -1,
    end: false,

    // 聚焦
    addFocus: false,
    // 分享状态
    glmsShare: false,
    // 分享状态选中的list
    sharedIdList: [],
    showShareLoginDialog: false,
    clickSession: false,
    curAssist: {}, // 当前对话智能体
    quoteMarkdownText: '', // 引用markdown文本
    currentSessionIsOver: false, // 当前会话是否结束
    showGoBottom: false,
    expandStatus: getLocalStorage('expandStatus') !== 'false', // 是否展开历史记录
    showSidebar: false // 长文档解读是否展示历史记录
  },
  mutations: {
    SET_SHOW_GO_BOTTOM: (state, showGoBottom) => {
      state.showGoBottom = showGoBottom
    },
    SET_CLICK_SESSION: (state, clickSession) => {
      state.clickSession = clickSession
    },
    SET_SHOW_SHARE_LOGIN_DIALOG(state, showShareLoginDialog) {
      state.showShareLoginDialog = showShareLoginDialog
    },
    REMOVE_SHARE_ID_LIST: (state, logId) => {
      const index = state.sharedIdList.findIndex(item => item.log_id === logId)
      if (index !== -1) {
        state.sharedIdList.splice(index, 1)
      }
    },
    SET_CLEAR_SHARE_INFO(state) {
      state.glmsShare = false
      state.sharedIdList = []
      state.currentOnClickedStatus = false
    },
    SET_CURRENT_ON_CLICKED_STATUS: (state, currentOnClickedStatus) => {
      state.currentOnClickedStatus = currentOnClickedStatus
    },
    SET_SHARE_ID_LIST: (state, sharedId) => {
      state.sharedIdList.push(sharedId)
    },
    SET_CLEAR_SHARE_ID_LIST: (state, sharedIdList = []) => {
      state.sharedIdList = sharedIdList
    },
    SET_GLMS_SHARE: (state, glmsShare) => {
      state.glmsShare = glmsShare
    },
    SET_STATUS: (state, status) => {
      state[status.name] = status.value
    },
    SET_MODE: (state, mode) => {
      state.mode = mode
    },
    SET_MODELINDEX: (state, thumbsUpModelIndex) => {
      state.thumbsUpModelIndex = thumbsUpModelIndex
    },
    SET_DATA_LIST: (state, dataList) => {
      state.defaultObjet = {}
      state.dataList = dataList
    },
    RESET_DATA_LIST: (state, dataList) => {
      state.defaultObjet = {}
      state.dataList = []
    },
    SET_REVIEW_FROM_HISTORY: (state, reviewFromHistory) => {
      state.reviewFromHistory = reviewFromHistory
    },
    SET_THUMBINPUTFOCUS_STATUS: (state, thumbInputFocus) => {
      state.thumbInputFocus = thumbInputFocus
    },
    SET_INIT_STATUS: (state, initStatus) => {
      state.initStatus = initStatus
    },
    NEW_SESSION: state => {
      state.conversationId = ''
      state.dataList = []
      state.addFocus = true
    },
    SET_ADDFOCUS: (state, val) => {
      state.addFocus = val
    },
    SET_CUR_ASSIST: (state, val) => {
      state.curAssist = val
    },
    [SET_SELECTION_MARKDOWN_TEXT]: (state, val) => {
      state.quoteMarkdownText = val
    },
    [SET_CURRENT_SESSION_IS_OVER]: (state, val) => {
      state.currentSessionIsOver = val
    },
    REST_DATA: state => {
      state.isSearching = false
    },
    SET_EXPAND_STATUS: (state, val) => {
      state.expandStatus = val
      setLocalStorage('expandStatus', val)
    },
    SET_SHOW_SIDEBAR: (state, val) => {
      state.showSidebar = val
    }
  },
  getters: {
    selectedAllStatus({ dataList, sharedIdList }) {
      const list = dataList.filter(
        item =>
          item.printComleted &&
          !item.forbidden &&
          !item.manualStopStream &&
          (!item.is_sensitive || item.is_intervene)
      )
      return list.length === sharedIdList.length
    },
    isProd(state) {
      return state.mode === conversationStatus.prod
    },
    // 取最后一个
    lastItem(state) {
      const len = state.dataList.length - 1
      return state.dataList[len] || state.defaultObjet
    },
    isSensitiveStatus(state) {
      return state.dataList.some(data => data.is_sensitive)
    },
    isForbiddenStatus(state) {
      return state.dataList.some(data => data.forbidden)
    },
    isLoading(state, getter) {
      return getter.lastItem.isLoading
    }
  },
  actions: {}
}

export default Conversation
